export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-2c-e5abd617729cecfd36c3c45db3e336a5.webp";